<mat-card fxLayout="column">
  <h2 translate>requestFinance.title</h2>
  <div *ngIf="hasAnyFinancing() || !loading; else showNoFinancing">
    <mat-label *ngIf="showFirstDayPayment" translate [translateParams]="{ expirationDate: expired }"
      >requestFinance.firstExpiration
    </mat-label>
    <mat-label translate *ngIf="haveDeadline"> requestFinance.deadlines</mat-label>
    <form [formGroup]="financeForm">
      <table aria-label="request-finance" mat-table [dataSource]="dataSource.data">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <mat-radio-group formControlName="finance">
              <mat-radio-button
                (click)="onclick(element)"
                [checked]="selection.isSelected(element)"
                (change)="changeElementFinance(element, $event)"
                [value]="element"
              >
              </mat-radio-button>
            </mat-radio-group>
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef translate>requestFinance.type</th>
          <td mat-cell *matCellDef="let element">{{ element.description }}</td>
        </ng-container>
        <ng-container matColumnDef="term">
          <th mat-header-cell *matHeaderCellDef translate>numPlaz</th>
          <td mat-cell *matCellDef="let element" translate>
            {{ element.plazoSal }}
          </td>
        </ng-container>
        <ng-container matColumnDef="firstCuota">
          <th mat-header-cell *matHeaderCellDef translate>requestFinance.quota</th>
          <td mat-cell *matCellDef="let element">{{ element.firstShare }} €</td>
        </ng-container>
        <ng-container matColumnDef="cuota">
          <th mat-header-cell *matHeaderCellDef translate>requestFinance.status</th>
          <td mat-cell *matCellDef="let element">{{ element.share }} €</td>
        </ng-container>
        <ng-container matColumnDef="lastCuota">
          <th mat-header-cell *matHeaderCellDef translate>requestFinance.lastQuota</th>
          <td mat-cell *matCellDef="let element">{{ element.lastShare }} €</td>
        </ng-container>
        <ng-container matColumnDef="tin">
          <th mat-header-cell *matHeaderCellDef translate>requestFinance.tin</th>
          <td mat-cell *matCellDef="let element">{{ element.tin }}</td>
        </ng-container>
        <ng-container matColumnDef="cae">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.cae</th>
          <td mat-cell *matCellDef="let element">{{ element.cae }}</td>
        </ng-container>
        <ng-container matColumnDef="treatmentCae">
          <th mat-header-cell *matHeaderCellDef translate>requestFinance.cae</th>
          <td mat-cell *matCellDef="let element">{{ element.treatmentCAE }}</td>
        </ng-container>
        <ng-container matColumnDef="tae">
          <th mat-header-cell *matHeaderCellDef translate>requestFinance.tae</th>
          <td mat-cell *matCellDef="let element">{{ element.tae }}</td>
        </ng-container>
        <ng-container matColumnDef="safe">
          <th mat-header-cell *matHeaderCellDef translate>requestFinance.insurance</th>
          <td mat-cell *matCellDef="let element" translate>
            {{ element.insuranceDescription === '' ? 'requestFinance.noProteccion' : element.insuranceDescription }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <div *ngIf="isCalculator" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
        <button id="createRequestFinance" mat-flat-button type="button" color="primary" (click)="createRequest()">
          <mat-label translate> requestFinance.buttonCreate </mat-label>
        </button>
        <button
          id="exportControlPanel"
          mat-flat-button
          type="button"
          color="primary"
          (click)="onClickPrintControlPanel()"
        >
          <mat-label>{{ 'requestFinance.buttonExport' | translate | uppercase }}</mat-label>
        </button>
      </div>
    </form>
  </div>
  <ng-template #showNoFinancing>
    <div fxLayout="column" fxLayoutAlign="center center">
      <mat-label translate>requestFinance.noFinancing</mat-label>
      <mat-label translate>requestFinance.validationEntries</mat-label>
    </div>
  </ng-template>
</mat-card>
